export default __webpack_public_path__ + "static/media/logoNew.c4b626dd.svg";